import { Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { EventData } from '../providers/event';

@Pipe({
  name: 'staffData'
})

export class StaffDataPipe implements PipeTransform {

  constructor(
    private eventData: EventData
  ) { }

  transform(value: string, clientId: string): Observable<any> {
    return this.eventData.getStaffData(clientId, value);
  }
}


// WEBPACK FOOTER //
// ./src/pipes/staff-data.pipe.ts